import React, { ReactElement } from "react"

const DividerPaywall: React.FC<{}> = (): ReactElement => {
  return <p className="text-dark4 text-base text-center mb-4">oder</p>
}

export default DividerPaywall
